import { render, staticRenderFns } from "./fornecedor-resumo.vue?vue&type=template&id=160ad847&scoped=true"
import script from "./fornecedor-resumo.vue?vue&type=script&lang=js"
export * from "./fornecedor-resumo.vue?vue&type=script&lang=js"
import style0 from "./fornecedor-resumo.vue?vue&type=style&index=0&id=160ad847&prod&scoped=true&lang=css"
import style1 from "./fornecedor-resumo.vue?vue&type=style&index=1&id=160ad847&prod&scoped=true&lang=css"
import style2 from "./fornecedor-resumo.vue?vue&type=style&index=2&id=160ad847&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ad847",
  null
  
)

export default component.exports